export enum DemandResponseState {
  PENDING = 'PENDING',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  DENIED = 'DENIED',
  EXPIRED = 'EXPIRED',
}
